import { render, staticRenderFns } from "./expansion-panels.vue?vue&type=template&id=483c913c"
import script from "./expansion-panels.vue?vue&type=script&lang=js"
export * from "./expansion-panels.vue?vue&type=script&lang=js"
import style0 from "./expansion-panels.vue?vue&type=style&index=0&id=483c913c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports